"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const useDebounce_1 = require("../../utils/hooks/useDebounce");
const Button_1 = require("../Button");
const defaultProps = {
    "data-testid": "carousel-button",
};
const CarouselButton = (_a) => {
    var { iconName, className, disabled, onClick } = _a, rest = __rest(_a, ["iconName", "className", "disabled", "onClick"]);
    const classList = (0, classnames_1.default)("carousel-button", className);
    return ((0, jsx_runtime_1.jsx)(Button_1.Button
    /* the onclick has been debounced to prevent wrong animation if user click compulsively */
    , Object.assign({ 
        /* the onclick has been debounced to prevent wrong animation if user click compulsively */
        onClick: (0, useDebounce_1.useDebounceFn)(onClick, 250), rounded: true, className: classList, iconName: iconName, disabled: disabled }, rest)));
};
CarouselButton.defaultProps = defaultProps;
exports.default = CarouselButton;
